module.exports = __webpack_public_path__ + "img/liqpay.9da03f63.png";